import { path } from 'utils'
import { z } from 'zod'

import { OperationLevelPermission } from '../auth-claims/permissions'
import { defineApi } from '../http'
import { manyItems } from '../shared'
import { sharedItemSchema } from './agronomy-row'
import { streamOverviewSchema } from './stream-overview'

/** A stored stream-overview row: the overview payload plus shared row identity. */
export const streamOverviewRowSchema = streamOverviewSchema.merge(sharedItemSchema)

export type StreamOverviewRow = z.infer<typeof streamOverviewRowSchema>

/** Every stream overview for an organization's crop and season. */
export const streamOverviewsApi = defineApi({
  name: 'GetStreamOverviews',
  description: "Retrieve every stream's overview for an organization's crop and season.",
  method: 'GET',
  requiredPermissions: OperationLevelPermission.ViewApplicationData,
  pathSchema: z.object({ orgCode: z.string() }),
  querySchema: z.object({ season: z.coerce.number(), crop: z.string() }),
  pathFor: ({ orgCode, season, crop }) =>
    path(`/tailor/${orgCode}/streams/overviews`, { season, crop }),
  gatewayPath: '/:orgCode/streams/overviews' as const,
  responseSchema: manyItems(streamOverviewRowSchema)
})
